import type { IBasketFlowStepId } from '@booking-portal/types/basket-flow-types';
import { isString } from 'lodash-es';

export const navigationNames = {
  accountOverview: 'account-overview',
  auth: 'auth',
  authAttempt: 'auth-attempt',
  login: 'login',
  logout: 'logout',
  forbidden: 'forbidden',
  errorInvalidDomain: 'error-invalid-domain',
  serverError: 'server-error',
  notFound: 'not-found',

  customerPortalUpdatePaymentMethod: 'customer-portal-update-payment-method',
  customerPortalUpdatePaymentMethodVerify:
    'customer-portal-update-payment-method-verify',
  customerPortalSharedAccess: 'customer-portal-shared-access',

  redirectIdCheck: 'customer-portal-redirect-id-check',
};

export const guardNames = {
  authenticatedGuard: 'authenticated-guard',
  notAuthenticatedGuard: 'not-authenticated-guard',
  hasSharedAccess: 'has-shared-access',
  requiresLanguage: 'requires-language',
} as const;

export type IGuardName = (typeof guardNames)[keyof typeof guardNames];

export function getMiddleware(middleware: IGuardName | IGuardName[]): {
  middleware: IGuardName[];
} {
  const middlewares = isString(middleware) ? [middleware] : middleware;

  return {
    middleware: middlewares,
  };
}

export interface IAppRouteMeta {
  middleware?: IGuardName[];
  /**
   * If guard is `is-authenticated-guard` or ``
   */
  redirectOnLogout?: boolean;

  /**
   * An array containing the allowed checkout steps for this route (if applicable). If the current step value is not inside this array, the user will be redirected to the best suitable route.
   *
   * E.g. If the step returned from the API is `payment` then the payment page and the payment-verify page should be accessible, but not the id-check or e-signature pages. So the payment pages should have `['payment', 'payment-verify']` as allowed steps, while the id-check page should have `['id-check', 'id-check-in-progress', 'id-check-expired', 'id-check-cancelled']` and so on.
   */
  allowedCheckoutSteps?: IBasketFlowStepId[];
}
